// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3820d84b","455":"bad11209","977":"afe12208"}[chunkId] + ".chunk.js";
};